import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, Output, EventEmitter, Input } from '@angular/core';
import { OperationsService } from 'src/app/core/services/operations.service';
import { Observable, Subject } from 'rxjs';
import { ServicePathsSettings } from 'src/app/core/configuration/service-paths-settings';
import { PropertiesSettings } from 'src/app/core/configuration/properties-settings';
import { Controparte } from 'src/app/common/models/controparte';
import { CreazionePraticaStoreService } from '../../../services/creazione-pratica-store.service';
import { Parte } from 'src/app/common/models/parte';
import { takeUntil } from 'rxjs/operators';
import { refreshContropartePrimaria } from '../../../utils/controparti-utils';
import { DocumentoAllegato } from 'src/app/common/models/documento-allegato';
import { stepMap } from '../../creazione-pratica-stepper/config/step';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { ViewManagerService } from 'src/app/core/services/view-manager-service';
import { ConfigurationUtilService } from 'src/app/core/services/configuration-util-service';
import { ModalNotifyService } from 'src/app/core/services/modal-notify.service';

@Component({
  selector: 'list-controparti',
  templateUrl: './list-controparti.component.html',
  styleUrls: ['./list-controparti.component.css']
})
export class ListContropartiComponent implements OnInit, OnChanges, OnDestroy {

  readonly PROPERTIES_SETTINGS = PropertiesSettings;

  msgEmpty: string;

  labelButton = 'Disassocia'

  disabled = false;

  controparti: Controparte[] = [];

  optionsList: { hasDetailsAnagrafica: boolean, controparte: Controparte }[] = [];


  activeIndex: number;

  editParte: Controparte;

  private componentDestroyed$: Subject<void> = new Subject<void>();
  @Input() sezione = null;
  @Input() fascicolo = null;
  writable: boolean;
  @Output() onReturn: EventEmitter<{controparte: Controparte; type: string}> = new EventEmitter<{controparte: Controparte; type: string}>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDropDownEvent: EventEmitter<DropDownEvent> = new EventEmitter<DropDownEvent>();
  @Output() onDocumentEvent: EventEmitter<DocumentEvent> = new EventEmitter<DocumentEvent>();
  currentTab: String = "ASSOCIATIVA";
  accordions = stepMap;
  editing = false;

  indexContropartePrimaria: number;


  constructor(
    private viewManager: ViewManagerService,
    private operations: OperationsService,
    private configurationUtil: ConfigurationUtilService,
    private creazionePraticaStoreService: CreazionePraticaStoreService,
    private modalNotifyService: ModalNotifyService) {
      this.configurationUtil.descrittoriMap.subscribe(descrittore => {
        if(descrittore) {
          this.writable = descrittore[NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO].writable
        }
      })
  }

  ngOnInit() {
    this.creazionePraticaStoreService.controparti$.pipe(takeUntil(this.componentDestroyed$)).subscribe(controparti => {
      this.optionsList = [];
      if (controparti && controparti.length > 0) {
        this.controparti = controparti;
        controparti.forEach(element => {
          const option = { hasDetailsAnagrafica: false, controparte: element }
          this.optionsList.push(option)
        });
        if (this.optionsList.length === 1) {
          this.optionsList[0].controparte.primario = true;
        }
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnDestroy() {
    this.componentDestroyed$.next();
  }

  openDetail(option: { hasDetailsAnagrafica: boolean, controparte: Controparte }, indice: number) {
    if (this.activeIndex === undefined || this.activeIndex !== indice) {
      this.activeIndex = indice;
      this.editing = false;
    } else {
      this.editing = false;
      this.activeIndex = undefined;      
    }

  }

  disassocia(option: { hasDetailsAnagrafica: boolean, controparte: Controparte }, indice: number) {
    this.onDelete.emit(option);
    // this.controparti = this.controparti.filter(controparte => controparte.parte.id !== option.controparte.parte.id)
    // this.creazionePraticaStoreService.setControparti(this.controparti);
    // this.creazionePraticaStoreService.save();
  }

  retrieveParte(controparte: Controparte, option: { hasDetailsAnagrafica: boolean, controparte: Controparte }) {
    this.editParte = controparte;
    if (controparte) {
      option.controparte = controparte;
      this.editParte = undefined;
    }
  }

  retrieveControparte(controparteRetrieved: Controparte) {
    this.onReturn.emit({controparte: controparteRetrieved, type: "modifica"});
    // let contropartiFiltred = refreshContropartePrimaria(this.controparti,controparteRetrieved);
    // this.controparti = contropartiFiltred;
    // this.creazionePraticaStoreService.setControparti(this.controparti);
    // this.creazionePraticaStoreService.save();
    this.editing = false;
    this.activeIndex = undefined;
  }

  onEmitUpdateAnagrafica(parte: Parte, controparteRetrieved: Controparte){
    controparteRetrieved.parte = parte;
    this.operations.updateAnagraficaElementParte(parte).subscribe(
      response => {
        this.onReturn.emit({controparte: controparteRetrieved, type: "modifica"})
      }
    );
    this.editing = false;
    this.activeIndex = undefined;
  }

  displayAddDocModal(sezione, controparte) {
    this.onDropDownEvent.emit({ eventType: "allegato", controparte: controparte });
   }

  setAsPrimaria(controparte: Controparte) {
    this.onDropDownEvent.emit({ eventType: "primaria", controparte: controparte });
  }

  disattivaControparte(controparte) {
    this.onDropDownEvent.emit({ eventType: "disattiva", controparte: controparte });
  }

  elimina(controparte: Controparte) {    
    this.onDelete.emit({ eventType: "elimina", controparte: controparte });
  }
  

  onReturnUpdateCallback(event) {
    this.onDocumentEvent.emit(
      {
        documento: event,
        eventType:  'modifica'
      }
    )
  }

  showUploadNewVersionModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'nuova-versione'
      }
    )
  }

  showHistoryModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'storico'
      }
    )
  }

  removeDoc(documento: DocumentoAllegato, entityId: string, sezioneId: string) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        entityId: entityId,
        sezioneId: sezioneId,
        eventType:  'elimina'
      }
    )
  }

  displayDocUpdateMetadatiModal(documento: DocumentoAllegato) {
    this.onDocumentEvent.emit(
      {
        documento: documento,
        eventType:  'metadati'
      }
    )
  }

}

type DropDownEvent = {
  controparte: Controparte,
  eventType: 'primaria' | 'allegato' | 'disattiva' | 'elimina'
}

type DocumentEvent = {
  documento: DocumentoAllegato,
  controparte?: Controparte,
  entityId?: string,
  sezioneId?: string,
  eventType: 'nuova-versione' | 'storico' | 'modifica' | 'elimina' | 'metadati'
}


